<template>
  <div>
    <div @click="openModal()">
      <div class="cursor-pointer"><vk-icon icon="move" /><span></span></div>
    </div>
  </div>
</template>

<script>
import EventBus from "../EventBus";
export default {
  name: "modalPermission",
  data() {
    return {
      model: null,
      show: false,
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },

  methods: {
    openModal() {
      EventBus.$emit("leadDetailModalShow", {
        id: this.model,
      });
    },
  },
};
</script>
